export default __webpack_public_path__ + "static/media/trash.f7f9f35e.svg";